export default __webpack_public_path__ + "static/media/ic_fail.2e778e28.svg";